import { render, staticRenderFns } from "./dialog-add-phone-number.vue?vue&type=template&id=160f3336&scoped=true&"
import script from "./dialog-add-phone-number.vue?vue&type=script&lang=js&"
export * from "./dialog-add-phone-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160f3336",
  null
  
)

export default component.exports